<div>
    <div class="input-row">
        <div>
            <input
                class="form-control form-control-sm"
                type="text"
                placeholder="Search User"
                [formControl]="userControl"
                [matAutocomplete]="auto"
            />
        </div>
        <div>
            <button
                (click)="clearSelectedUser()"
                class="btn btn-sm btn-warning"
            >
                Clear
            </button>
            <span *ngIf="selectedUser">
                <input
                    type="hidden"
                    name="user-id"
                    value="{{ selectedUser.id }}"
                />
                <input
                    type="hidden"
                    name="user-open_id"
                    value="{{ selectedUser.username }}"
                />
                <input
                    type="hidden"
                    name="user-email"
                    value="{{ selectedUser.email }}"
                />
            </span>
        </div>
    </div>
</div>

<mat-autocomplete
    (optionSelected)="setHiddenValues($event)"
    autoActiveFirstOption
    #auto="matAutocomplete"
>
    <mat-option *ngFor="let user of userResults" [value]="user.email">
        {{ user.email }}
    </mat-option>
</mat-autocomplete>
